export default "__VITE_ASSET__C6wB1edv__";